module.exports = {
  UNKNOWN_GUEST: 'Unknown Guest'
};
